import { gql } from "@apollo/client";

export const CREATE_SHIPMENT = gql`
  mutation CreateShipment($shipment: NewShipmentInput!) {
    createShipment(shipment: $shipment) {
      _id
      number
      number_string
      description
      tracking_number
      encoded_label
      contact_id
      customer_id
      type
    }
  }
`;

export const UPDATE_SHIPMENT = gql`
  mutation UpdateShipment($shipment: ShipmentInput!) {
    updateShipment(shipment: $shipment) {
      _id
      number
      number_string
      description
      tracking_number
      encoded_label
      contact_id
      customer_id
      type
      to {
        name
        company_displayable_name
        address1
        address2
        city
        state
        zip
        reference_id
      }
      from {
        name
        company_displayable_name
        address1
        address2
        city
        state
        zip
      }
      tickets {
        id
        number
        customer_id
        customer_business_then_name
        contact_id
        _id
      }
    }
  }
`;